<template>
  <div class="file-upload">
    <div v-show="!soloImagen" class="file-upload__label">
      <input type="file" :id="id" class="input-file" v-on:change="onFileChange" :accept="extensiones">
      <i class="fa fa-upload"></i>
      <label :for="id">Seleccionar archivo...</label>
    </div>
    <img class="file-upload__image" :class="{'file-upload__image--open': fileImage}" :src="image" @click="openImage" v-on-clickaway="away">
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  watch : {
    defaultImage : function (value) {
      this.image = value;
    }
  },
  mixins: [ clickaway ],
  props : {
    soloImagen : {
      type : Boolean,
      required : false,
      default : false
    },
    defaultImage : {
      type : String,
      default : '',
      required : false
    },
    id:{
      type:String,
      dafault:'file',
      required:false
    },
    value : {
      required : false,
      default : ''
    },
    extensiones:{
      required:true
    },
    tamanoMaximo:{
      required: false,
      default: 3000000
    },
    descripcionMaximo:{
      required: false,
      default: '3mb'
    }
  },
  data () {
    return {
      image: this.defaultImage,
      fileImage: false,
      imageReturn : null,
    }
  },
  methods: {
    openImage () {
      this.fileImage = !this.fileImage
    },
    away () {
      if (this.fileImage) {
        this.fileImage = false;
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      if(parseFloat(file.size) > parseFloat(this.tamanoMaximo)){
        swal.fire('Error','El peso del archivo no debe ser mayor a ' + this.descripcionMaximo, 'error')
      }else{
        //let formato = file.type.substring(file.type.length-3, file.type.length);
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.image = e.target.result;
          vm.imageReturn = e.target.result;
          // let formato = vm.image.substring(0,20);
          // if(formato == 'data:application/pdf'){
          //   vm.image = '/images/imagen-pdf.jpg';
          // }
          vm.$emit('input', vm.imageReturn);
        };
        reader.readAsDataURL(file);
      }
      
    },
    recuperarImagen() {    
      return this.imageReturn;
    },
    resetImagen() {
      this.image = null;
      this.imageReturn = null;
      document.getElementById(this.id).value = '';
    }
  },
  mounted : function(){
    // if(this.defaultImage != null && this.defaultImage != undefined){
    //   if(this.defaultImage.length>0){
    //     let formato = this.defaultImage.substring(this.defaultImage.length-3, this.defaultImage.length);
    //     if(formato == 'pdf' || formato == 'PDF'){
    //       this.image = '/images/imagen-pdf.jpg';
    //     }      
    //   }
    // }    
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/FileUpload2.vue